export default __webpack_public_path__ + "static/media/manage_domain_icon.a2afcf57.svg";